import * as ACTION_TYPES from "./action_types";

export const loginSuccess = (userProfile) => {
  return {
    type: ACTION_TYPES.LOGIN_SUCCESS,
    payload: userProfile
  };
};

export const logout = (userProfile) => {
  return {
    type: ACTION_TYPES.LOGOUT,
    payload: userProfile
  };
};

export const loginFailure = () => {
  return {
    type: ACTION_TYPES.LOGIN_FAILURE
  };
};
